import { usePayments } from '@/hooks/use-payments'
import { formatKES, formatPaymentMethod } from '@/lib/utils'

function formatDate(unixSeconds?: number) {
  if (!unixSeconds) return '—'
  return new Date(unixSeconds * 1000).toLocaleDateString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function MemberPaymentsPanel() {
  const { data, isLoading } = usePayments({ mine: true })
  const payments = data?.data ?? []

  if (isLoading) {
    return <p className="font-sans text-sm text-muted-foreground">Loading…</p>
  }
  if (payments.length === 0) {
    return (
      <p className="rounded border border-border-2 px-4 py-6 text-center font-sans text-sm text-muted-foreground">
        No payments recorded yet.
      </p>
    )
  }

  return (
    <div className="overflow-x-auto rounded border border-border-2">
      <table className="w-full font-sans text-sm">
        <thead>
          <tr className="border-b border-border-2 bg-cream-2 text-left text-label uppercase tracking-[0.08em] text-muted-foreground">
            <th className="px-4 py-3">Date</th>
            <th className="px-4 py-3">Invoice #</th>
            <th className="px-4 py-3">Amount</th>
            <th className="px-4 py-3">Method</th>
            <th className="px-4 py-3">Reference</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.id} className="border-b border-border-2 last:border-0">
              <td className="px-4 py-3 text-ink">{formatDate(p.paidAt)}</td>
              <td className="px-4 py-3 font-medium text-ink">{p.invoiceNumber}</td>
              <td className="px-4 py-3 text-ink">{formatKES(p.amount)}</td>
              <td className="px-4 py-3 text-ink">{formatPaymentMethod(p.method)}</td>
              <td className="px-4 py-3 text-muted-foreground">
                {p.mpesaReceiptNumber ?? p.reference ?? '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
